addEventListener( 'DOMContentLoaded', function () {
	document.querySelectorAll( '.b-parallax-cards' ).forEach( function ( block ) {
		const cards = block.querySelectorAll( '.b-parallax-cards__inner > .b-card-image' );

		if ( cards.length !== 3 ) {
			return;
		}

		const cardWidth = cards[ 0 ].offsetWidth;
		// The last card is always in its natural position (offset 0).
		// Each preceding card is offset further down as a fraction of card width.
		const cardOffsets = [ 0.48 * cardWidth, 0.24 * cardWidth, 0 ];

		// Set initial translateY on each card
		cards.forEach( function ( card, i ) {
			gsap.set( card, { y: cardOffsets[ i ] } );
		} );

		// Animate cards to y:0 as the block scrolls into the center of the viewport
		ScrollTrigger.create( {
			trigger: block,
			start: 'top bottom',   // when top of block enters bottom of viewport
			end: 'center center',  // when center of block reaches center of viewport
			scrub: true,
			onUpdate: function ( self ) {
				const progress = self.progress;
				cards.forEach( function ( card, i ) {
					gsap.set( card, { y: cardOffsets[ i ] * ( 1 - progress ) } );
				} );
			},
		} );
	} );
} );
